import {Component} from "@angular/core";
import {Field} from "../models/field.model";


@Component({
	selector: "tig-form-password",
	template: `
    <div
		class="form-group"
		[formGroup]="OBJ_form_group"
		[ngClass]="{'has-error': isInvalid()}">
		<label class="col-lg-2 control-label" [ngClass]="{'tgi-required': isRequired()}">{{getLabelName()|translate}}
            <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
		<div class="col-lg-8">
			<input
			class="form-control"
			(blur)="setValue($event)"
			[placeholder]="getLabelName()|translate"
			[readonly]="OBJ_field_config?.readonly"
			[formControlName]="OBJ_field_config.name"
			#password
			type="password" />
			<i [ngClass]="(password.type=='password'?'fa fa-eye tig-eye':'fa fa-eye-slash tig-eye')" (click)="showPassword(password)"></i>
            <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
		</div>
    </div>
  `
})
export class FormPasswordComponent extends Field
{


	/**
	 * Function > showPassword
	 * @param OBJ_input
	 */
	showPassword(OBJ_input: any): any
	{
		OBJ_input.type = (OBJ_input.type==="password")?"text":"password";
	} // end class showPassword


	setValue(event: any): void
	{
		super.setValue(event.value);
	}

} // end class FormPasswordComponent
